import { Inject, Injectable, InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';
import { isValidOAuthAuthorizationTransaction } from '../../_core/services/oauth-authorization-login-resume.service';

export { isValidOAuthAuthorizationTransaction } from '../../_core/services/oauth-authorization-login-resume.service';

export const OAUTH_AUTHORIZATION_WINDOW = new InjectionToken<Window>('OAuth authorization browser window', {
	providedIn: 'root',
	factory: () => window
});

@Injectable({ providedIn: 'root' })
export class OAuthAuthorizationBrowserService {
	constructor(@Inject(OAUTH_AUTHORIZATION_WINDOW) private readonly browserWindow: Window) {}

	isTopLevel(): boolean {
		try {
			return this.browserWindow.top === this.browserWindow.self;
		} catch {
			return false;
		}
	}

	complete(transaction: string): void {
		if (!isValidOAuthAuthorizationTransaction(transaction)) {
			throw new Error('Invalid OAuth authorization transaction.');
		}

		const apiBaseUrl = environment.apiUrl.replace(/\/+$/, '');
		this.browserWindow.location.replace(`${apiBaseUrl}/oauth/authorizations/${encodeURIComponent(transaction)}/complete`);
	}
}
